import { ProjectActionTypes } from '../actions/projectActions'

export interface Project {
  id: string
  name: string
  description?: string
  status: string
  technicalDetails?: string
  projectType?: 'TECH' | 'NON_TECH'
  updatedAt: string
  createdAt: string
  requirements?: any[]
  businessProcess?: {
    mermaidCode: string
    generatedAt: string
  } | null
  estimation?: any | null
  estimationConfig?: any | null
  preferences?: any
}

interface ProjectState {
  projects: Project[]
  activeProject: Project | null
  isLoading: boolean
  error: string | null
}

const initialState: ProjectState = {
  projects: [],
  activeProject: null,
  isLoading: false,
  error: null,
}

const projectReducer = (state = initialState, action: any): ProjectState => {
  switch (action.type) {
    case ProjectActionTypes.GET_PROJECTS_REQUEST:
    case ProjectActionTypes.CREATE_PROJECT_REQUEST:
    case ProjectActionTypes.GET_PROJECT_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }

    case ProjectActionTypes.GET_PROJECTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        projects: action.payload,
        error: null,
      }

    case ProjectActionTypes.GET_PROJECT_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activeProject: action.payload,
        error: null,
      }

    case ProjectActionTypes.CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        projects: [action.payload, ...state.projects],
        error: null,
      }

    case ProjectActionTypes.GET_PROJECTS_FAILURE:
    case ProjectActionTypes.CREATE_PROJECT_FAILURE:
    case ProjectActionTypes.GET_PROJECT_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default projectReducer